import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {EloquentManagerService} from "../../../shared/eloquent/providers/eloquent-manager.provider";
import {Project} from "../../../shared/eloquent/models/project.model";
import {LayoutService} from "../../../shared/services/layout/layout.service";
import {Subscription} from "rxjs/Subscription";
import {LanguageService} from "../../../shared/services/language/language.service";

declare const $: any;
declare const paths: any;
declare const Raphael: any;

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit, AfterViewInit, OnDestroy {

    public projectlist: Array<Project> = [];

    private languageSubscripton: Subscription;
    public currentLanguage = 'en';

    public selectedCityProjects = {
        ground: [],
        rooftop: []
    };

    constructor(private eloquentManager: EloquentManagerService,
                private layoutService: LayoutService,
                private languageService: LanguageService) {
        this.layoutService.setTitle('About');

        this.eloquentManager.list(Project).subscribe((response) => {
            if (response) {
                this.projectlist = response;
                console.log(this.projectlist);
                this.setCityColours();

            }
        });
    }

    ngOnInit() {
        this.subscribeLanguageEvents();
    }


    ngAfterViewInit(): void {
        this.createTurkishMap();
        setTimeout(this.initMapProperties, 1000);
    }


    ngOnDestroy(): void {
        this.unsubscribeLanguageEvents();
    }

    private subscribeLanguageEvents() {
        this.languageSubscripton = this.languageService.language.subscribe((val) => {
            this.currentLanguage = val;
        });
    }

    private unsubscribeLanguageEvents() {
        this.languageSubscripton.unsubscribe();
    }

    initMapProperties = () => {
        const $that = this;
        const cities = $('.cityPopupTrigger');
        cities.removeAttr('title');
        cities.parent().removeAttr('title');
        console.log(cities.length);
        cities.click(function () {
            const path = $(this);
            const modal = $('#cityModal');

            let cityID = $(this).attr('county');
            if (!$that.projectExistsInCity(cityID)) {
                return false;
            }

            let projectsInCity = $that.getProjectsByCity(cityID);

            $that.selectedCityProjects = {
                ground: projectsInCity.filter((project) => {
                    return project.application_type === 'ground'
                }),
                rooftop: projectsInCity.filter((project) => {
                    return project.application_type === 'rooftop'
                })
            };


            modal.modal({
                inverted: false,
                onShow: function () {
                    let header = ($that.currentLanguage == 'tr') ?  path.attr('displayName') + ' Şehrindeki Projeler' : 'Projects in ' + path.attr('displayName') + ' City';
                    modal.find('.header').html(header);
                },
                onHidden: function () {
                    this.selectedCityProjects = {
                        ground: [],
                        rooftop: []
                    };
                }
            }).modal('show');
        });
    };

    setCityColours = () => {
        const cities = $('.cityPopupTrigger');
        for (let i = 0; i < cities.length; i++) {
            let city = cities.eq(i);
            let cityID = city.attr('county');
            if (this.projectExistsInCity(cityID)) {
                city.addClass('has-project');
            }
        }
    };

    projectExistsInCity = (cityID) => {
        let filteredArray = this.projectlist.filter((project) => {
            return project.city.id === parseInt(cityID)
        });
        return filteredArray.length > 0;
    };

    getProjectsByCity = (cityID) => {
        return this.projectlist.filter((project) => {
            return project.city.id === parseInt(cityID)
        });
    };


    createTurkishMap = () => {


        var iscountyselected = false;
        var previouscountyselected = "blank";
        var start = true;
        var past = null;
        var content_dir = "details";

        $(function () {

            var r = Raphael('map'),
                attributes = {
                    fill: '#e0e0e0',
                    stroke: '#999',
                    'stroke-width': 0,
                    'stroke-linejoin': 'round',
                },
                arr = new Array();

            for (var county in paths) {

                var obj = r.path(paths[county].path);

                obj.attr(attributes);

                arr[obj.id] = county;


                obj.data('selected', 'notSelected');
                /* add ID to paths */
                obj.node.id = arr[obj.id];

                /* add title (for tooltip) to paths */
                obj.attr(attributes).attr({title: paths[arr[obj.id]].name}).data();
                obj.node.setAttribute('class', 'cityPopupTrigger');
                obj.node.setAttribute('displayName', paths[county].displayName);
                obj.node.setAttribute('county', paths[county].county);


                obj.click(function () {
                    /* @author: Taner DOGAN //START */
                    // $("#detail").click();
                    // $.get(content_dir + "/" + arr[this.id] + ".html", function (html) {
                    //     $("#detail").empty().fadeIn(700).append(html).css("display", "block");
                    //     $("#detail").css({
                    //         "position": "absolute",
                    //         "top": ((($("#detail").parent().height() + 100 - $("#detail").height()) / 2) + "px")
                    //     });
                    // }).error(function () {
                    //     warn = "<p style='text-align:center;'>Bu bölgede kayıt bulunamadı</p><a href='#' class='close'></a>";
                    //     $("#detail").empty().fadeIn(700).append(warn).css("display", "block");
                    // });
                    /* @author: Taner DOGAN //END */

                    if (paths[arr[this.id]].value == 'notSelected') {
                        this.animate({
                            fill: '#999'
                        }, 200);

                        paths[previouscountyselected].value = "notSelected";
                        paths[arr[this.id]].value = "isSelected";
                        //alert(paths[arr[this.id]].value = "isSelected");

                        //alert(arr[this.id] + previouscountyselected);
                        previouscountyselected = paths[arr[this.id]].name;

                        if (!start && past != this) {
                            past.animate({fill: '#e0e0e0'}, 200);
                        }
                        past = this;
                        start = false;
                    }


                    else if (paths[arr[this.id]].value == 'isSelected') {
                        this.animate({
                            fill: '#999'
                        }, 200);

                        paths[arr[this.id]].value = "notSelected";
                        /* set path value */
                    }

                });
                /* end mark selections */

                // /* county hover bump */
                // function hoverin(e) {
                //     if (paths[arr[this.id]].value == 'notSelected')
                //         this.animate({
                //             fill: '#262e35'
                //         }, 300);
                // }
                //
                // function hoverout(e) {
                //     if (paths[arr[this.id]].value == 'notSelected')
                //         this.animate({
                //             fill: '#e0e0e0'
                //         }, 300);
                // }
                //
                // obj.mouseout(hoverout);
                //
                // obj.mouseover(hoverin);
                /* end county hover bump */


                /* hide name div - !important do not delete - ajax uses contents for event search */
                // $('#countyInfo').hide();
                //
                // $('#spinner').hide();
                // /* @author: Taner DOGAN //START */
                // $(".close").live("click", function () {
                //     $("#detail").css("display", "none").empty();
                //     past.animate({fill: '#e0e0e0'}, 200);
                //     past.animate().mouseover(function () {
                //         this.animate({
                //             fill: '#262e35'
                //         }, 300);
                //     })
                //     past.animate().mouseout(function () {
                //         this.animate({
                //             fill: '#e0e0e0'
                //         }, 300);
                //     })
                // });

                /* @author: Taner DOGAN //END */


                /* end check on blank */
                /*Resize Map*/
                r.setViewBox(0, 0, 1050, 620, true);
                r.setSize("100%", "100%");
            }
            /* end raphael loop */

        });

    }

}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/about/about.component.ts